$(function(){
  if ($('#image_gallery').length > 0){
      $('#image_gallery').find('.image_asset').each(function(){
        var $this = $(this),
        $input_file = $this.find('input[type=file]');

        $this.on('click', '.edit', function(event){
          event.preventDefault();
          $input_file.trigger('click');
        });

        $input_file.on('change', function(){
          $this.find('img').attr({ src: '/assets/blank.png', alt: '' }).end().find('.download').remove();
        })
    });

    $('#image_gallery .cboxElement').colorbox({
      rel: 'route_image_galery',
      close: 'x',
      next: '<i class="ace-icon fa fa-arrow-right"></i>',
      previous: '<i class="ace-icon fa fa-arrow-left"></i>',
      current: "Immagine {current} di {total}"
    });
  }
});